import React, { Fragment, useState } from "react";
import SliderCards from "./SliderCards";
import { UseGetTrendingProducts } from "../../../staticQueries/useGetTrendingProducts";

function TypeButton({ isActive, children, ...props }) {
  return (
    <button
      className={`bg-transparent rounded-full ${
        isActive
          ? "lg:bg-[#1f1f1f] text-black lg:text-white hover:bg-opacity-80"
          : "text-black hover:text-[#1f1f1f]"
      } ${
        isActive && "border-2 border-solid border-black"
      } text-[15px] md:text-base sm:font-bold box-border
      lg:border-none px-6 md:px-[30px] py-2 md:py-[10px]`}
      {...props}
    >
      {children}
    </button>
  );
}

function ProductsSection() {
  const trendingProducts = UseGetTrendingProducts();
  const [productCategory, setProductCategory] = useState(
    trendingProducts.BestSeller
  );

  return (
    <Fragment>
      <div className="w-full px-5 xl:px-[90px] box-border pt-[30px] lg:pt-[90px]">
        <div className="flex flex-wrap justify-between">
          <h2 className="md:min-w-[370px] w-max mt-5 text-center lg:text-left text-3xl md:text-4xl font-bold mb-[10px] lg:mb-5">
            Explore trending products
          </h2>
          <div className="flex w-full lg:w-fit items-center justify-center lg:justify-end gap-y-4 mt-5">
            <TypeButton
              isActive={
                productCategory.handle === trendingProducts.BestSeller.handle
              }
              onClick={() => setProductCategory(trendingProducts.BestSeller)}
            >
              {trendingProducts.BestSeller.title}
            </TypeButton>
            <TypeButton
              isActive={productCategory.handle === trendingProducts.New.handle}
              onClick={() => setProductCategory(trendingProducts.New)}
            >
              {trendingProducts.New.title}
            </TypeButton>
          </div>
        </div>
      </div>
      <div className="flex py-[30px] pl-5 xl:pl-[90px] mb-10 md:mb-[90px] box-border justify-between">
        {/* <div className="w-1/4 relative hidden lg:flex text-white">
          {productCategory.image?.gatsbyImageData && (
            <div className="absolute w-full h-full top-0 rounded-xl z-[-1]">
              <GatsbyImage
                image={productCategory.image.gatsbyImageData}
                alt={productCategory.image.altText || productCategory.title}
                loading="lazy"
                className="relative w-full h-full rounded-xl z-[-1] object-cover"
              />
            </div>
          )}
          <div className="m-auto z-10 flex flex-col items-center">
            <h5 className="font-bold text-white text-center text-3xl">
              {productCategory.title}
            </h5>
            <button
              className="max-w-[130px] bg-transparent mx-auto mt-2 px-4 text-center py-2 border border-solid border-[#E2E8F0]
            rounded-full transform transition-all duration-150 ease-linear hover:scale-105"
            >
              <Link
                to={`/collections/${productCategory.handle}`}
                className="no-underline text-white my-[10px] w-full text-center"
              >
                View all
              </Link>
            </button>
          </div>
        </div> */}
        <div className="flex flex-col w-full">
          <SliderCards
            data={productCategory.products}
            handle={productCategory?.handle}
          />
        </div>
      </div>
    </Fragment>
  );
}

export default React.memo(ProductsSection);
